// src/utils/statusHelpers.js
import React from 'react';
import {
  CheckCircle,
  Warning,
  Error as ErrorIcon,
  Receipt,
  Pending as PendingIcon,
  LocationSearching as LocationSearchingIcon,
  LocationOn as LocationOnIcon,
  Build as BuildIcon,
  Assignment as AssignmentIcon,
} from "@mui/icons-material";

export const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case "paid":
    case "completed":
      return "success";
    case "unpaid":
    case "overdue":
    case "incomplete":
      return "error";
    case "partially paid":
    case "pending":
    case "travelling":
      return "warning";
    case "on site":
    case "in progress":
      return "info";
    default:
      return "default";
  }
};

export const getStatusIcon = (status) => {
  switch (status?.toLowerCase()) {
    case "paid": return <CheckCircle fontSize="small" />;
    case "unpaid": return <ErrorIcon fontSize="small" />;
    case "overdue": return <Warning fontSize="small" />;
    case "partially paid": return <Warning fontSize="small" />;
    case "pending": return <PendingIcon fontSize="small" />;
    case "travelling": return <LocationSearchingIcon fontSize="small" />;
    case "on site": return <LocationOnIcon fontSize="small" />;
    case "in progress": return <BuildIcon fontSize="small" />;
    case "completed": return <CheckCircle fontSize="small" />;
    case "incomplete": return <ErrorIcon fontSize="small" />;
    default: return <Receipt fontSize="small" />;
  }
};
